// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2-HXK","title":"Images45_title__1P0FF","images":"Images45_images__3zmFF"};